export const isCompletedByDoctor = (type?: string | null) => {
  return type === 'doctor';
};

export const isCompletedByAgencyDoctor = (type?: string | null) => {
  return type === 'agencyDoctor';
};
